(() => {
  const start = Date.parse('2026-10-01T00:00:00+02:00');
  const end = Date.parse('2026-11-01T00:00:00+01:00');
  const key = 'Ascent oktobercadeau';
  const note = '1 Ascent-parfumstarterspakket assorti cadeau. Controleer bij inpakken: definitief aankoopbedrag na korting vanaf EUR 300 excl. verzending; besteld van 1 t.e.m. 31 oktober 2026.';
  const active = () => Date.now() >= start && Date.now() < end;
  const root = window.Shopify?.routes?.root || '/';
  let pending = false;
  let running = false;
  let lastCart;

  function render(cart) {
    lastCart = cart;
    const eligible = active() && cart.currency === 'EUR';
    const qualified = eligible && cart.total_price >= 30000;
    document.querySelectorAll('[data-cp-ascent-note]').forEach(input => {
      input.value = qualified ? note : '';
    });
    document.querySelectorAll('[data-cp-ascent-gift]').forEach(panel => {
      panel.hidden = !eligible;
      if (panel.dataset.cpAscentGift !== 'cart' || !eligible) return;
      const amount = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(Math.max(0, 30000 - cart.total_price) / 100);
      const text = qualified ? panel.dataset.qualified : panel.dataset.remaining.replace('[amount]', amount);
      const message = panel.querySelector('[data-cp-ascent-message]');
      if (message.textContent.trim() !== text.trim()) message.textContent = text;
    });
    return qualified ? note : '';
  }

  async function sync() {
    pending = true;
    if (running) return;
    running = true;
    try {
      while (pending) {
        pending = false;
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) break;
        const cart = await response.json();
        const value = render(cart);
        if ((cart.attributes?.[key] || '') !== value) {
          const updated = await fetch(root + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { [key]: value } })
          });
          if (updated.ok) render(await updated.json());
        }
      }
    } catch (_) {
    } finally {
      running = false;
    }
  }

  function init() {
    if (!active() && !document.querySelector('[data-cp-ascent-existing="true"]')) return;
    const panel = document.querySelector('[data-cp-ascent-gift="cart"]');
    if (panel) render({ total_price: Number(panel.dataset.total), currency: panel.dataset.currency });
    const events = window.FoxThemeEvents;
    if (events?.subscribe) {
      events.subscribe('ON_ITEM_ADDED', () => sync());
      events.subscribe('ON_CART_UPDATED', cart => {
        if (cart && typeof cart.total_price === 'number') render(cart);
        sync();
      });
      events.subscribe('ON_CART_DRAWER_OPEN', () => sync());
    }
    if (active() || document.querySelector('[data-cp-ascent-existing="true"]')) sync();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && (active() || lastCart)) sync();
    });
    if (Date.now() < end && Date.now() >= start) {
      const expire = () => {
        if (active()) setTimeout(expire, Math.min(end - Date.now() + 100, 86400000));
        else {
          document.querySelectorAll('[data-cp-ascent-gift]').forEach(panel => { panel.hidden = true; });
          document.querySelectorAll('[data-cp-ascent-note]').forEach(input => { input.value = ''; });
          sync();
        }
      };
      expire();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
